// axiosConfig.js
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { store } from '../app/store'; // named import instead of default
import { logout } from '../features/authSlice';
import config from '../config';

const api = axios.create({
  baseURL: config.url, // use config for consistency
});

api.interceptors.request.use(
  (config) => {
    // Check for both user and admin tokens
    const userToken = localStorage.getItem('authToken');
    const adminToken = localStorage.getItem('adminAuthToken');
    
    // Use admin token if available, otherwise use user token
    const token = adminToken || userToken;
    
    if (token) {
      const { exp } = jwtDecode(token);
      const currentTime = Date.now();

      if (exp * 1000 < currentTime) {
        // Handle logout based on token type
        if (adminToken) {
          // Admin token expired - redirect to admin login
          localStorage.removeItem('adminAuthToken');
          localStorage.removeItem('adminData');
          localStorage.removeItem('adminRoles');
          localStorage.removeItem('adminPermissions');
          window.location.href = '/admin/login';
        } else {
          // User token expired - use regular logout
          store.dispatch(logout());
          localStorage.removeItem('authToken');
          window.location.href = '/login';
        }
        throw new axios.Cancel('Session expired');
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
